module.exports = __webpack_public_path__ + "img/cooling-water-smog-equipment-2.d284e2f4.png";